// @ts-nocheck
import React, { useEffect, useState } from 'react';
import HTMLReactParser from 'html-react-parser';
import { useContentLanguage } from 'store';
import { useUserData } from 'hooks';
import UserService from 'services/userServices';
import { useSelector } from 'react-redux';
import { RootState } from 'redux/store';

interface ThirdPartyScriptProps {
  showFeedback: boolean;
}

const ThirdPartyScript = ({ showFeedback }: ThirdPartyScriptProps) => {
  const [snippet, setSnippet] = useState('');
  const [globalContentLanguage] = useContentLanguage();
  let userData = useUserData();
  const userCountry: string = UserService.checkUserCountry(userData);
  const { generalConfig } = useSelector((state: RootState) => state.configReducer);
  
  useEffect(() => {
    const getQualtricsSnippet = async () => {
      const configValue = generalConfig?.qualtricsSnippet || null;
      if (configValue && !!userData?.user_name) {
        const snippet= configValue.snippet;
        const disabled_countries = configValue.disabled_countries || [];
        const snp = disabled_countries.includes(userCountry) ? '' : snippet;
        if (!!snp) {
          setSnippet(atob(snp));
        }
      }
    };
    getQualtricsSnippet();
  }, [generalConfig?.qualtricsSnippet, userData?.user_name, userCountry]);

  useEffect(() => {
    if(!showFeedback) return;
    if (!!snippet) {
      HTMLReactParser(snippet, {
        replace: function (domNode) {
          if (domNode.type === 'script') {
            const code = domNode.children[0].data;
            const script = document.createElement("script");
            script.type = "text/javascript";
            script.textContent = code;
            document.body.appendChild(script);
          } else if (domNode.type === 'tag' && domNode.name === 'div') {
            let div = document.createElement('div');
            div.setAttribute('id', domNode.attribs.id);
            document.head.appendChild(div);
          }
        }
      });
    }
  }, [snippet, showFeedback]);

  useEffect(() => {
    const languageCode = globalContentLanguage.toUpperCase();
    window.Q_Language = languageCode;
    window.LANGUAGE = languageCode;

    if (window.QSI) {
      window.QSI.API.unload();
      window.QSI.API.load().done(() => {
        window.QSI.API.run();
      });
    }
  }, [globalContentLanguage]);

  return <></>;
};

export default ThirdPartyScript;
